import ViewBase from "../../../../../framework/core/mvvm/view_base";
import PlayerSettingChildBaseView from "../player_setting_childbase_view";

const { ccclass, property } = cc._decorator;

@ccclass
export default class PlayerPaibeiChooseView extends PlayerSettingChildBaseView {
    
}